import { useEffect, useMemo, useState } from "react";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const API_BASE = API_ROOT
  ? (API_ROOT.endsWith("/api") ? API_ROOT : `${API_ROOT}/api`)
  : "/api";
const ALLOWED_MODULES = [1, 3, 7, 13];

const JOB_TYPE_MAP = {
  P: "Permanent",
  T: "Temporary Basis",
  C: "Contractual",
  D: "Daily Wages"
};

const SERVICE_TYPE_MAP = {
  N: "NonTeaching",
  T: "Teaching",
  A: "Academic Staff"
};

function formatDate(value) {
  if (!value || value === "0000-00-00") {
    return "";
  }

  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) {
    return "";
  }

  const day = String(dt.getDate()).padStart(2, "0");
  const month = String(dt.getMonth() + 1).padStart(2, "0");
  const year = dt.getFullYear();
  return `${day}/${month}/${year}`;
}

export default function SeniorityList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const localUser = useMemo(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const employeeId = Number.parseInt(localUser?.id, 10);
  const moduleId = Number.parseInt(localUser?.moduleId, 10);

  useEffect(() => {
    const load = async () => {
      if (!employeeId || !moduleId) {
        setError("Unauthorized access Or Session Timed out.");
        setLoading(false);
        return;
      }

      if (!ALLOWED_MODULES.includes(moduleId)) {
        setError("Unauthorized access Or Session Timed out.");
        setLoading(false);
        return;
      }

      try {
        setError("");
        setLoading(true);

        const params = new URLSearchParams({
          employeeId: String(employeeId),
          moduleId: String(moduleId)
        });

        const response = await fetch(`${API_BASE}/employees/seniority-list?${params.toString()}`);
        const payload = await response.json();

        if (!response.ok) {
          throw new Error(payload?.message || "Failed to fetch seniority list");
        }

        setRows(Array.isArray(payload?.data) ? payload.data : []);
      } catch (err) {
        setRows([]);
        setError(err.message || "Failed to fetch seniority list");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [employeeId, moduleId]);

  return (
    <section className="container-fluid">
      <h3 className="mb-3">Seniority List</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
            <tr>
              <th>SNo</th>
              <th>Name</th>
              <th>Gender</th>
              <th>Father&apos;s Name</th>
              <th>Mobile</th>
              <th>PF</th>
              <th>Merit</th>
              <th>DOC</th>
              <th>DOJ</th>
              <th>DOB</th>
              <th>Valid Upto</th>
              <th>Designation</th>
              <th>Department</th>
              <th>Job Type</th>
              <th>Service Type</th>
            </tr>
          </thead>
          <tbody>
            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan={15} className="text-center text-muted">No records found.</td>
              </tr>
            )}
            {loading && (
              <tr>
                <td colSpan={15} className="text-center text-muted">Loading...</td>
              </tr>
            )}
            {rows.map((row, index) => (
              <tr key={`${row.EmployeeID}-${index}`}>
                <td>{index + 1}</td>
                <td>{row.EmpName || ""}</td>
                <td>{row.Gender || ""}</td>
                <td>{row.FatherName || ""}</td>
                <td>{row.Mobile || ""}</td>
                <td>{row.PFNo || ""}</td>
                <td>{row.MeritRank || ""}</td>
                <td>{formatDate(row.DOC)}</td>
                <td>{formatDate(row.DOJ)}</td>
                <td>{formatDate(row.DOB)}</td>
                <td>{formatDate(row.DOR)}</td>
                <td>{row.Designation || ""}</td>
                <td>{row.Department || ""}</td>
                <td>{JOB_TYPE_MAP[row.JobType] || row.JobType || ""}</td>
                <td>{SERVICE_TYPE_MAP[row.EmpType] || row.EmpType || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
